import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUser } from '../../../../hooks/useUser';

export function ForceLogout() {
  const navigate = useNavigate();
  const { logout, userResult } = useUser();

  useEffect(() => {
    if (!userResult?.loading && userResult?.user) {
      logout({});
    } else if (!userResult?.loading && !userResult?.user) {
      navigate('/');
    }
  }, [navigate, userResult?.user, userResult?.loading, logout]);

  return null;
}

export default ForceLogout;
